module.exports = __webpack_public_path__ + "img/menuIcon26.709e21f4.png";